import * as React from "react"

import { StyledTableCell as TableCell } from "@/components/Table/styles"
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  LinearProgress,
  Table,
  TableBody,
  TableRow,
} from "@material-ui/core"
import { useQuery } from "react-query"
import { getPalletBatchByOrderItem } from "@/http/miscellaneous/getPalletBatches"
import formatter from "@/services/formatter"

export function OutletDetailTable({ orderItemId }) {
  const { data, isLoading } = useQuery(
    ["order-item-pallet-batch", orderItemId],
    () => getPalletBatchByOrderItem({ orderItemId }),
    {
      enabled: !!orderItemId,
      staleTime: 1000 * 5,
    }
  )

  if (isLoading) {
    return (
      <Box bgcolor="grey.50" padding="1rem">
        <Box maxWidth="50%">
          <LinearProgress />
        </Box>
      </Box>
    )
  }

  return (
    <Box bgcolor="grey.50" padding="1rem">
      <Box maxWidth="50%">
        <Card>
          <CardContent>
            <CardHeader title={`# ${data.cod_etiqueta}`} />

            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell>CÓDIGO</TableCell>
                  <TableCell>PRODUTO</TableCell>
                  <TableCell>LOTE</TableCell>
                  <TableCell align="right">TON.</TableCell>
                  <TableCell align="right">BIT.</TableCell>
                  <TableCell align="right">(M²)</TableCell>
                  <TableCell align="right">(Cxs)</TableCell>
                </TableRow>

                {data.items.map((item) => {
                  const tag = item.pallet_tag

                  return (
                    <TableRow key={item.id_itens}>
                      <TableCell>{tag.cod_produto}</TableCell>
                      <TableCell>{tag.product_description?.dsc_item}</TableCell>
                      <TableCell>{tag.etiq_lote}</TableCell>
                      <TableCell align="right">{tag.etiq_tonalidade}</TableCell>
                      <TableCell align="right">{tag.etiq_bitola}</TableCell>
                      <TableCell align="right">
                        {formatter(tag.etiq_qtde).toDecimal(2)}
                      </TableCell>
                      <TableCell align="right">{tag.etiq_qtde_cx}</TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </Box>
    </Box>
  )
}
